import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchProducts = createAsyncThunk('fetchProducts', async (cred, thunkAPI) => {
    return axios
        .get("https://royalzimonline.pythonanywhere.com/main/products/") 
        .then(response => response.data)
        .catch(err => err.message)
})

export const fetchProductsSlice = createSlice({
    name: 'fetchProducts',
    initialState: {
        loading: false,
        products: '',
        error: ''
    },
    reducers: {

    },
    extraReducers: builder => {
        builder.addCase(fetchProducts.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchProducts.fulfilled, (state, action) => {
            state.loading = false
            state.products = action.payload
            state.error = ''
        })
        builder.addCase(fetchProducts.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })
    }
})

export default fetchProductsSlice.reducer